export default __webpack_public_path__ + "static/media/PPI-pools-006.b4d193e2.jpg";